// @packages
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import CtrlAccordionSearch from '../controls/toolkit/ctrl-accordion-search';
import CtrlCandidateGrid from '../controls/toolkit/ctrl-candidate-grid';
import getSearchInputObject, { getCategoryType } from '../../helpers/searchInput';
import initialState from './initial-state';
import searchInputs from './search-inputs';
import { isAllPropsValid } from '../../helpers';
import _ from 'lodash';

// @styles
import styles from './styles';
import { useParams } from 'react-router';
// import { getByDisplayValue } from '@testing-library/dom';

const CandidateGridDisplay = ({
    candidateProducts,
    searchInputsState,
    classes,
    id,
    onAddItemToSchedule,
    onClearCandidateProducts,
    onGetCandidateProducts,
    onGetSearchInputs
}) => {
    const Categ = useParams();
    const pCategory = Categ.page;
    const [cat, setCat] = useState(getCategoryType(pCategory));

    useEffect(() => {
        onClearCandidateProducts();
        async function fetchMyAPI() {
            let response = await onGetSearchInputs({
                params: { "dto": cat }
            });
        }
        fetchMyAPI();
    }, []);

    const [state, setState] = useState(initialState);

    if (searchInputsState.certificates) {
        searchInputs[1].fields[0].items = searchInputsState.certificates;
        searchInputs[2].fields[0].items = searchInputsState.louversDepth;
        searchInputs[2].fields[2].items = searchInputsState.bladeStyle;
    }
    // const handleOnChangeIncludeDriveLoss = ({ name, value }) => {
    //     setState({
    //         ...state,
    //         [name]: {
    //             value
    //         }
    //     });
    // };

    const handleOnSearh = () => onGetCandidateProducts(getSearchInputObject(state, pCategory));
    const handleOnFieldChange = ({ name, isValid, value }) => {
        if (name !== "pressure" && name === "selectionmethod" && value === "1") {
            setState({
                ...state,
                [name]: {
                    isValid,
                    value
                },
                pressure: {
                    isValid: name === "selectionmethod" && value === "1" ? true : false,
                    value: name === "selectionmethod" && value === "1" ? null : state.pressure.value
                },
                height: {
                    isValid: state.height.value !== null? true:false,
                    value: state.height.value !== null? state.height.value : null
                },
                width: {
                    isValid: state.width.value !== null? true:false,
                    value: state.width.value !== null? state.width.value : null
                }
            });
        }
       else if (name !== "height" && name === "selectionmethod" && value === "2") {
            setState({
                ...state,
                [name]: {
                    isValid,
                    value
                },
                height: {
                    isValid: name === "selectionmethod" && value === "2" ? true : false,
                    value: name === "selectionmethod" && value === "2" ? null : state.height.value
                },
                pressure: {
                    isValid: state.pressure.value !== null? true:false,
                    value: state.pressure.value !== null? state.pressure.value : null
                },
                width: {
                    isValid: state.width.value !== null? true:false,
                    value: state.width.value !== null? state.width.value : null
                }
            });
        }
        else if (name !== "width" && name === "selectionmethod" && value === "3") {
            setState({
                ...state,
                [name]: {
                    isValid,
                    value
                },
                width: {
                    isValid: name === "selectionmethod" && value === "3" ? true : false,
                    value: name === "selectionmethod" && value === "3" ? null : state.width.value
                },
                pressure: {
                    isValid: state.pressure.value !== null? true:false,
                    value: state.pressure.value !== null? state.pressure.value : null
                },
                height: {
                    isValid: state.height.value !== null? true:false,
                    value: state.height.value !== null? state.height.value : null
                }
            });
        }
        else {
            setState({
                ...state,
                [name]: {
                    isValid,
                    value
                }
            });

        }
    };
    const handleOnEnterClick = () => {
        if (isAllPropsValid(state)) {
            handleOnSearh();
        }
    };
    const getIsValid = ({ name, isValid, value }) => {
        if (name === "selectionmethod")
            isValid = value === "1" ? true : false;
        return isValid;
    }

    const getControlValue = ({ name, isValid, value }) => {
        //value =   name ==="selectionmethod" && value === "1" ? true : isValid;
        return value;
    }

    const getSearchInputs = () => {
        const ppSearchInputs = JSON.parse(JSON.stringify(searchInputs));
        if (state.selectionmethod.value === "1") {
            ppSearchInputs[0].fields = _.remove(ppSearchInputs[0].fields, x => { return !(x.name === 'pressure') });
        }
        if (state.selectionmethod.value === "2") {
            ppSearchInputs[0].fields = _.remove(ppSearchInputs[0].fields, x => { return !(x.name === 'height') });
        }
        if (state.selectionmethod.value === "3") {
            ppSearchInputs[0].fields = _.remove(ppSearchInputs[0].fields, x => { return !(x.name === 'width') });
        }
        return ppSearchInputs;
    };

    const handleOnFieldBlur = ({ name, value }) => {
        setState({
            ...state,
            [name]: {
                ...state[name],
                value
            }
        });
    };

    return (
        <Grid id={id} container>
            <Grid item xs={12}>
                <CtrlAccordionSearch
                    id={`${id}-accordion-search`}
                    //onChangeIncludeDriveLoss={handleOnChangeIncludeDriveLoss}
                    //onClickDriveLossMode={handleOnClickDriveLossMode}
                    onFieldBlur={handleOnFieldBlur}
                    onFieldChange={handleOnFieldChange}
                    onEnterClick={handleOnEnterClick}
                    searchInputs={getSearchInputs()}
                    state={state}
                />
            </Grid>
            <Grid item xs={12} className={classes.searchButton}>
                <Button
                    color="primary"
                    disabled={!isAllPropsValid(state)}
                    onClick={handleOnSearh}
                    variant="contained"
                >
                    Search
                </Button>
            </Grid>
            <Grid item xs={12}>
                <CtrlCandidateGrid
                    category={pCategory}
                    dataSource={candidateProducts}
                    id={`${id}-candidate`}
                    onAddItemToSchedule={onAddItemToSchedule}
                />
            </Grid>
        </Grid>
    );
};

CandidateGridDisplay.propTypes = {
    candidateProducts: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    onAddItemToSchedule: PropTypes.func.isRequired,
    onClearCandidateProducts: PropTypes.func.isRequired,
    onGetCandidateProducts: PropTypes.func.isRequired
};

export default withStyles(styles)(CandidateGridDisplay);
